// extracted by mini-css-extract-plugin
export default {"table":"files-tableю_table__x0eBJ","tableFileIcon":"files-tableю_tableFileIcon__qYBQS","eyeIcon":"files-tableю_eyeIcon__2rZ3O"};